import React, { createContext, useContext, useState } from 'react';
import loginStyles from '../../../stylesheets/components/login.module.scss';
import LoginHeader from './LoginHeader';
import LoginFooter from './LoginFooter';
import { useLocation } from 'react-router-dom';
import SomethingWentWrongAlert from './SomethingWentWrongAlert';
import LoginPMLogo from './LoginPMLogo';

interface LoginBodyProps {
  children: React.ReactNode;
}

const LoginBodyPortalTargetContext = createContext<HTMLDivElement | null>(null);

export const useLoginBodyPortalTarget = () => {
  return useContext(LoginBodyPortalTargetContext);
};

const LoginBody = ({ children }: LoginBodyProps) => {
  const location = useLocation();
  const [portalTarget, setPortalTarget] = useState<HTMLDivElement | null>(null);
  const isSignupAgreementRoute = location.pathname === '/signup_agreement';
  const showFooter = !isSignupAgreementRoute;
  const activationLinkError =
    location.state?.prevPage === 'activate' ? (
      <SomethingWentWrongAlert body="Login activation link is invalid." />
    ) : null;

  return (
    <LoginBodyPortalTargetContext.Provider value={portalTarget}>
      <div
        id="login-body"
        ref={setPortalTarget}
        className={loginStyles.loginBody}
      >
        {isSignupAgreementRoute ? (
          <div className={loginStyles.loginHeader}>
            <div className={loginStyles.loginHeaderLogo}>
              <LoginPMLogo />
            </div>
          </div>
        ) : (
          <LoginHeader />
        )}
        <div className={loginStyles.loginContent}>
          {location.state?.prevPage === 'activate' && activationLinkError && (
            <div className={loginStyles.loginBodyAlert}>
              {activationLinkError}
            </div>
          )}
          {children}
        </div>
        {showFooter && <LoginFooter />}
      </div>
    </LoginBodyPortalTargetContext.Provider>
  );
};

export default LoginBody;
